// src/components/molecules/MediaUpload.js

import React, { useState } from "react";
import { Box } from "@mui/material";
import UploadButton from "../atoms/UploadButton";

const MediaUpload = ({ mediaType, onFileSelect }) => {
  const [preview, setPreview] = useState(null);

  const handleFileSelect = (file) => {
    onFileSelect(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Box mb={2}>
      <UploadButton onFileSelect={handleFileSelect} />
      {preview && (
        <Box mt={2}>
          {mediaType === "image" ? (
            <img
              src={preview}
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          ) : (
            <video
              src={preview}
              controls
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default MediaUpload;
